import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { IEvent } from '@/enitites/event/model/types'
import { useRouter, useRoute } from 'vue-router/composables'
import { computed } from 'vue'
import IconEdit from '@/shared/icons/IconEdit.vue'
import ToggleLike from '@/features/toggle-like/ui/ToggleLike.vue'
import IconLike from '@/shared/icons/IconLike.vue'
import { EVENT_STAR_CONFIG } from '../constants'

interface Props {
  event?: IEvent
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFeedbackBlock',
  props: {
    event: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { event: IEvent };

// @ts-expect-error JS file


const router = useRouter()
const route = useRoute()

const getUserDB = computed(() => store.getters.getUserDB)

const handleClickBottomButton = () => {
  if (getUserDB.value) {
    if (router.currentRoute.query.tab !== 'feedback') {
      router.push({
        name: 'Event',
        params: { id: `${props.event?.id}` },
        query: { tab: 'feedback' },
      })
    }
  } else {
    router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
  }
}

return { __sfc: true,props, router, route, getUserDB, handleClickBottomButton, BKSvgIcon, IconEdit, ToggleLike, IconLike, EVENT_STAR_CONFIG }
}

})